import { useState, useRef, useEffect, useCallback } from 'react'
import { Container, Tab, SelectStatus, Content, List } from './styled';
import { Option } from './Option';
import { Search } from '../Search';
import { GroupDefault } from '../../contexts/auth';
import { getUsersSystem } from '../../service/serviceChat/usersService';

export function TransferClient(props) {

    const {
        open,
        close,
        customer,
        customersIDs
    } = props;

    const refCheckbox1 = useRef(null);
    const refCheckbox2 = useRef(null);


    const [disable, setDisable] = useState(false);
    const [selectTab, setSelectTab] = useState('U');
    const [checkbox1, setCheckbox1] = useState(true);
    const [checkbox2, setCheckbox2] = useState(true);
    const [usersAndGroup, setUsersAndGroup] = useState([]);
    const [search, setSearch] = useState('');


    const searchUsersAndGroups = useCallback(async () => {
        const response = await getUsersSystem();
        setUsersAndGroup(
            response.filter((obj) =>
                obj.id !== GroupDefault()
                &&
                obj.id !== customer?.usuario_id
            )
        );
    }, []);
    useEffect(() => {
        refCheckbox1.current.checked = true
        refCheckbox2.current.checked = true
        searchUsersAndGroups();
    }, [open]);


    const verificationStatus = () => {
        if (selectTab === 'G') return '';
        if (checkbox1 && checkbox2) return '';
        if (checkbox1) return 'ONLINE';
        if (checkbox2) return 'OFFLINE';
        return false;
    }
    function onFilter(obj) {
        return (
            obj?.nomecompleto?.toLowerCase()?.includes(search?.toLowerCase())
            &&
            obj?.tipo?.includes(selectTab)
            &&
            obj?.status?.includes(verificationStatus())
        );
    }

    return (
        <Container loading={disable ? 1 : 0}>
            <div className='options--'>
                <Tab>
                    <div
                        className={`tabName ${selectTab === 'U' && 'select'}`}
                        onClick={() => setSelectTab('U')}
                    >
                        Usuário
                    </div>
                    <div
                        className={`tabName ${selectTab === 'G' && 'select'}`}
                        onClick={() => setSelectTab('G')}
                    >
                        Setor
                    </div>
                </Tab>
                <SelectStatus disabled={selectTab === 'G' ? 1 : 0}>
                    <span>
                        <input
                            type="checkbox"
                            ref={refCheckbox1}
                            onChange={() => setCheckbox1(!checkbox1)}
                        />
                        Online
                    </span>
                    <span>
                        <input
                            type="checkbox"
                            ref={refCheckbox2}
                            onChange={() => setCheckbox2(!checkbox2)}
                        />
                        Offlines
                    </span>
                </SelectStatus>
            </div>
            <Content>
                <div className='search--usersAndGroup'>
                    <Search
                        className=""
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
                <List>
                    {usersAndGroup.length > 0 &&
                        usersAndGroup.filter(onFilter).map((item) =>
                            <Option
                                key={item.id}
                                onDisable={() => setDisable(true)}
                                user={item}
                                customer={customer ?? null}
                                customersIDs={customersIDs}
                                close={close}
                            />
                        )
                    }
                </List>
            </Content>
        </Container>
    );
}